import { useEffect, useState } from 'react';
import { Sun, Moon } from 'lucide-react';

const KEY = 'ssl-theme';
export const applyTheme = (t) => {
  document.documentElement.classList.toggle('light', t === 'light');
  document.documentElement.classList.toggle('dark', t !== 'light');
};

export const ThemeToggle = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem(KEY) || 'dark');
  useEffect(() => { applyTheme(theme); localStorage.setItem(KEY, theme); }, [theme]);
  const light = theme === 'light';
  return (
    <button data-testid="theme-toggle" aria-label={light ? 'Mode nuit' : 'Mode jour'} title={light ? 'Mode nuit' : 'Mode jour'}
      onClick={() => setTheme(light ? 'dark' : 'light')}
      className="h-9 w-9 grid place-items-center rounded-full border border-black/15 text-black hover:bg-[#FFD400] hover:border-[#FFD400] transition-colors">
      {light ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
};
